import { DashboardSlice } from "./dashboard-slice";

export { getDashboardDetailsThunk } from "slices/dashboard/dashboard-thunk";

export default DashboardSlice.reducer;

export const { setMonthReducer } = DashboardSlice.actions;
